import React from "react";

import { FnrCombobox } from "UI/FnrSelectList3";

import ExtendedFieldErrorMessage from "./ExtendedFieldErrorMessage";
import getIconName from "./getIconName";
import { Label, RequiredIcon } from "./styles";

export default function PickerField({
  value = [],
  onChange,
  field,
  error,
  accentColor,
  ...rest
}) {
  const { icon, multiSelect, title, options, inputIsRequired } = field;

  const opts = options.map((option) => {
    return { id: option.ID, value: option.title };
  });

  return (
    <div {...rest}>
      <Label>
        {title}
        {inputIsRequired && <RequiredIcon />}
      </Label>

      <FnrCombobox
        selection={value}
        onSelect={(selection) => {
          let selectionIsArray = Array.isArray(selection);
          onChange(selectionIsArray ? selection : [selection]);
        }}
        options={opts}
        icon={getIconName(icon)}
        multiselect={multiSelect}
        openIndicator={true}
        selectionTextAlign="start"
        focusSize="2px"
        iconColor={accentColor}
        focusColor={accentColor}
        fontSize="18px"
        style={{
          background: "#fff",
          paddingLeft: "8px",
          paddingRight: "8px",
          fontWeight: 400,
          width: "100%",
          color: "#222",
        }}
      />
      {error ? (
        <ExtendedFieldErrorMessage className="fam_reg_error_msg">
          {error}
        </ExtendedFieldErrorMessage>
      ) : null}
    </div>
  );
}
